<template>
    <Container class="container-sm-none">
        <Card class="card-shadow">
            <div class="width-lg">
                <div class="pl-10 pl-md-0 pr-10 pr-md-0">
                    <DigitalSignatureSms
                      v-if="showDigitalSignatureSms"
                      :model="model" :uuid="model.saveResponse.uuid"
                      :errors="errors"
                    />
                  <DigitalSignatureRedirection
                    v-else
                    :model="model"/>
                </div>
            </div>
        </Card>
    </Container>
</template>

<script>
import distributionChannels from '@/mixins/distributionChannels';
import enums from '@/mixins/enums';
import Container from '@/components/Container/Container.vue';
import Card from '@/components/Card/Card.vue';
import DigitalSignatureSms
from '@/pagesComponents/DigitalSignatureComponents/DigitalSignatureSms.vue';
import GA from '@/mixins/GA';
import DigitalSignatureRedirection
from '@/pagesComponents/DigitalSignatureComponents/DigitalSignatureRedirection.vue';

export default {
  name: 'DigitalSignatureSmsPage',
  mixins: [distributionChannels, enums, GA],
  props: {
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  components: {
    DigitalSignatureRedirection,
    Container,
    Card,
    DigitalSignatureSms,
  },
  created() {
    this.model.step = 22;
    if (this.model.lastStep < 22) this.model.lastStep = 22;
  },
  methods: {
    /*
    * Returns true if current device is mobile
    * */
    isMobile() {
      const toMatch = [/Android/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
      return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
    },
  },
  mounted() {
    this.funnelStep('Digitálny podpis');
  },
  computed: {
    showDigitalSignatureSms() {
      return !this.isMobile() || (this.isMobile() && this.isVIP && this.model.delivery.eSignatureDevice === this.enums.DeviceEnum.ON_ANOTHER_DEVICE);
    },
  },
};
</script>
